import React, { useState, useEffect, useRef } from 'react';
import './style.scss';
import Axios from 'axios';
import { DEV_URL } from '../constants';
import { CrossIcon, Bell } from '../images';
import LearnMore from '../LearnMore';

const ThankyouMessage = (props) => {
    return (
        <div className={['thankyou__message']}>
            <div className={['thankyou__message__title']}>Thanks for lending your voice! You can speed up the change by:</div>
            <ol>
                <li>
                    Directly emailing your child's school principal at <span style={{ fontWeight: '600' }}>
                        {props.submittedSchool.email}
                    </span>, to be heard!!
                </li>
                <li>
                    Sharing this petition page with other concerned parents.
                </li>
            </ol>
        </div>
    )
}

const CerebryForm = (props) => {
    const [inputFocusSchool, setinputFocusSchool] = useState(false);
    const [inputSchool, setinputSchool] = useState('');
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState('');
    const [schooList, setschoolList] = useState([]);
    const [filterSchoolName, setfilterSchoolName] = useState([]);
    const [showThankyou, setShowThankYou] = useState(undefined);
    const [submittedSchool, setSubmittedSchool] = useState('');
    const [toggleLearnMore, setToggleMore] = useState(false);
    const inputElForm = useRef();

    const handleSchoolName = (e) => {
        setinputSchool(e.target.value)
        let inputValue = e.target.value;
        const filterList = schooList.filter((value) => value.name.toUpperCase().indexOf(inputValue.toUpperCase()) > -1);
        setfilterSchoolName(filterList);
    }
    const handleInputFocus = (status) => {
        setinputFocusSchool(status);
    }

    useEffect(() => {
        if (!!props.selectedCity) {
            const api__url = DEV_URL + `api/v2/petitions/city/${props.selectedCity.id}/schools/`
            Axios.get(api__url)
                .then((resp) => {
                    setschoolList(resp.data)
                    setfilterSchoolName(resp.data)
                })
                .catch((err) => {
                    console.log("err", err)
                })
        }
        document.addEventListener('mousedown', handleClickOutsideOption, false);
        return () => {
            document.removeEventListener('mousedown',handleClickOutsideOption, false);
        }
    }, [props.selectedCity])

    const selectSchoolNameFromList = (value) => {
        setinputSchool(value.name)
        setinputFocusSchool(false)
        setShowThankYou(undefined);
    }

    const handleMessage = (e) => {
        setMessage(e.target.value);
    }

    const handleEmail = e => {
      setEmail(e.target.value);
    }

    const handleToggleLearnMore = () => {
        setToggleMore(!toggleLearnMore);
    }

    const handleClickOutsideOption = (event) => {
        if (inputElForm.current && !inputElForm.current.contains(event.target)) {
            setinputFocusSchool(false)
          }
    };

    const handleSubmit = () => {
        const findId = schooList.find((value) => value.name === inputSchool)
        if (!!findId) {
            const api__url = DEV_URL + `api/v2/petitions/school/${findId.id}/petition/`
            Axios.post(api__url, message.length > 0 && {
                text: message,
                email: email
            })
                .then((resp) => {
                    setShowThankYou(true);
                    setSubmittedSchool(findId);
                })
                .catch((err) => {
                    console.log("err", err)
                })
        }
        else {
            setShowThankYou(false);
        }
    }

    return (
        <div  className={[['cerebry__form'], [showThankyou === true && 'thankyou__active']].join(" ")}>
            <div onClick={handleToggleLearnMore} className={['cerebry__form__learnmore']}>
                What is this about? Learn more
            </div>
            <div className={['dorm__heading']}>Sign the Parent's Petition to demand change</div>
            <div ref={inputElForm}>
              <input
                  className={[['cerebry__form__input'], [showThankyou === false && 'error']].join(" ")}
                  onChange={handleSchoolName}
                  value={inputSchool}
                  onFocus={() => { handleInputFocus(true) }}
                  placeholder="School Name"
              />
              {
                  inputFocusSchool &&
                  <div className={['dropdown__list__container']}>
                      {
                          filterSchoolName.map((value, index) => {
                              return (
                                  <div key={index} onClick={e => selectSchoolNameFromList(value)} className={['dropdown__list__container__each']}>
                                      {value.name}
                                  </div>
                              )
                          })
                      }
                  </div>
              }
            </div>
            <input
                className={[['cerebry__form__input'], [showThankyou === false && 'error']].join(" ")}
                onChange={handleEmail}
                value={email}
                placeholder="Your email address"
            />
            <div className={['cerebry__form__textarea__contain']}>
                <textarea
                    value={message}
                    disabled={filterSchoolName.length === 0 ? true : false}
                    onChange={handleMessage}
                    placeholder="Leave a comment anonymously for the Principal"
                    className={['cerebry__form__textarea']}
                />
                {
                    !message.length > 0 &&
                    <span className={['cerebry__form__textare__input']}>
                        Eg: Please adopt the latest Maths learning tools urgently so my son stops suffering Maths anxiety!
                </span>
                }
            </div>
            <div onClick={handleSubmit} className={[['cerebry__form__petition__button'], [filterSchoolName.length === 0 && 'disabled']].join(" ")}>
                Sign Parent's Petition
            </div>
            {!showThankyou && <div className={['cerebry__form__footer']}>Your details will never be revealed to the school</div>}
            {
                showThankyou === true &&
                <ThankyouMessage submittedSchool={submittedSchool} />
            }
            {
                toggleLearnMore === true &&
                <LearnMore handleToggleLearnMore={handleToggleLearnMore} />
            }
        </div>
    )
}
const CerebryRightContainer = (props) => {
    const [pettionList, setPetitionList] = useState([]);
    useEffect(() => {
        if (!!props.selectedCity) {
            const api__url = DEV_URL + `api/v2/petitions/city/${props.selectedCity.id}/trending-petitions/`;
            Axios.get(api__url)
                .then((resp) => {
                    setPetitionList(resp.data)
                })
                .catch((error) => {
                    console.log("error", error)
                })
        }
    }, [props.selectedCity])

    return (
        <div className={['cerebry__right__container']}>
            <div className={['cerebry__right__header']}>
              <div className={['bell__icon']}><Bell /></div>
              Trending School Principals
            </div>
            <div className={['trend__list']}>
            {
                pettionList.map((value, index) => {
                    return (
                        <div style={{ marginBottom: '11.5px' }} key={index}>
                            <div className={['cerebry__principal__name']}>
                                {index + 1}.    {value.principal}
                            </div>
                            <div className={['cerebry__school__name']}>
                                {value.school}
                            </div>
                            <div className={['cerebry__school__petition']}>
                                +{value.petition_count} Petitions this week
                            </div>
                            <div className={['cerebry__school__message']}>
                                {value.messages[0]}
                                <div onClick={() => { props.handleToggleParentComment(value) }} className={['cerebry__school__comments']}>
                                    More parents' comments
                                    <svg width="4.31" height="7.634" viewBox="0 0 4.31 7.634"><g transform="translate(-3.203 -2.161)"><g transform="translate(3.203 9.795) rotate(-90)"><path d="M3.819,4.31a.5.5,0,0,1-.352-.144L0,.7.7,0,3.819,3.116,6.935,0l.7.7L4.166,4.166A.5.5,0,0,1,3.819,4.31Z" transform="translate(0)"/></g></g></svg>
                                </div>
                            </div>
                            <div onClick={() => { props.handleIsThisYou(true) }} className={['cerebry__isthisyou']}>
                                Is this you?
                            </div>
                            <div className={['underline']}></div>
                        </div>
                    )
                })
            }
            </div>
        </div>
    )
}

const CerebryParentComment = (props) => {
    return (
        <div className={['cerebry__parent__container']}>
            <div className={['cerebry__parent__main']}>
                <div className={['cerebry__parent__header']}>
                    <div className={['cerebry__parent__header__name']}>
                        {props.data.principal}
                    </div>
                    <div className={['cerebry__parent__header__school']}>
                        {props.data.school}
                    </div>
                    <div onClick={() => {props.handleToggleParentComment([]);props.handleIsThisYou(true);}} className={['cerebry__parent__is__you']}>
                        Is this you?
                    </div>
                    <span onClick={() => { props.handleToggleParentComment([]) }} className={'cerebry__parent___cancel__icon'}>
                        <CrossIcon />
                    </span>
                </div>
                <div className={['cerebry__parent__com__list']}>
                    <h1>Some of the comments received from parents</h1>
                    <div style={{ marginBottom: '15px' }}>
                        {
                            props.data.messages.map((value, index) => {
                                return (
                                    <div key={index} className={['each-comment']}>
                                        {value}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )

}
const CerebryFormContainer = (props) => {
    const [toggleParentComment, setToggleParentComment] = useState({ status: false, data: [] });
    const handleToggleParentComment = (value) => {
        setToggleParentComment({ status: !toggleParentComment.status, data: value });
    }

    return (
        <div className={['cerebry__form__container']}>
            <CerebryForm selectedCity={props.selectedCity} />
            <CerebryRightContainer
                selectedCity={props.selectedCity}
                handleToggleParentComment={handleToggleParentComment}
                handleIsThisYou={props.handleIsThisYou}
            />
            {
                toggleParentComment.status === true &&
                <CerebryParentComment
                    handleToggleParentComment={handleToggleParentComment}
                    data={toggleParentComment.data}
                    handleIsThisYou={props.handleIsThisYou}
                />
            }
        </div>
    )
}

export default CerebryFormContainer;
